import { useForm } from 'react-hook-form';

import { useUrlQueryParam } from '@neo.tax/shared';

import { DefaultSignupForm } from './DefaultSignupForm';
import { SignupFormValues } from './signup-form.types';

export const SignupForm = (): React.ReactElement => {
  // Pre-populate the email when arriving from an invite link or a post-verification redirect
  // (?prefillEmail=…). It stays editable — this only seeds the field's default value.
  const prefillEmail = useUrlQueryParam('prefillEmail');
  const { control, formState, handleSubmit, watch } = useForm<SignupFormValues>({
    mode: 'onChange',
    defaultValues: {
      email: prefillEmail ?? '',
      fullName: '',
      password: '',
      confirmPassword: '',
      tosAccepted: false,
    },
  });

  return <DefaultSignupForm control={control} formState={formState} handleSubmit={handleSubmit} watch={watch} />;
};
